import { Navigate } from 'react-router-dom'
import { ReactNode } from 'react'
import { useAuth } from '../../hooks/useAuth'

interface Props {
  children: ReactNode
}

export function ProtectedRoute({ children }: Props) {
  const { isAuthenticated } = useAuth()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return children as JSX.Element
}
